import { CurrentPostContextProvider } from "@circle-react/contexts";
import { MainContent } from "./MainContent";

interface EventViewListItemProps {
  onPostChange: (post: any) => void;
  onPostDestroy: (post: any) => void;
  post: any;
  refetchPosts: () => void;
  shouldHideShareLink: boolean;
}

export const EventViewListItem = ({
  post,
  ...props
}: EventViewListItemProps) => (
  <CurrentPostContextProvider post={post}>
    <MainContent {...props} />
  </CurrentPostContextProvider>
);
